// Accordion.js
import React, { useState } from "react";

export const AccordionItem = ({ header, isExpanded, onToggle, children }) => (
  <div className="faq-content-block accordion-block">
    <div
      className={`accordion-header ${isExpanded ? "expanded" : ""}`}
      onClick={onToggle}
    >
      <h3>{header}</h3>
      <span className="icon" />
    </div>
    {isExpanded && (
      <div className="accordion-content">
        <div className="inner-content">{children}</div>
      </div>
    )}
  </div>
);

export const Accordion = ({ items }) => {
    
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggle = (i) =>
    setExpandedIndex(expandedIndex === i ? null : i);

  return (
    <>
      {items.map((item, i) => (
        <AccordionItem
          key={i}
          header={item.question}
          isExpanded={expandedIndex === i}
          onToggle={() => toggle(i)}
        >
          {item.answer}
        </AccordionItem>
      ))}
    </>
  );
};
